// extracted by mini-css-extract-plugin
module.exports = {"flexRow":"_1mDXK","partner":"_1aq9u","maskWrapper":"_22rMd","user":"_2uUQV","threeDotsButton":"_1IAMs","employeesTable":"_3rT1v"};